import { createContext } from "react"

export const DashboardsProjectsContext = createContext()

export const DashboardsMonitoringContext = createContext()